import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_BUS_MAINTENANCE_STAY,
  CLEAR_BUSSES_MAINTENANCE_STAY,
  FLAG_BUS_MAINTENANCE_STAY,
  FLAG_GETTING_BUSSES_MAINTENANCE_STAY,
  GET_BUS_MAINTENANCE_STAY,
  GET_BUSSES_MAINTENANCE_STAY,
  GET_ITINERARY_ARRIVALS,
  FLAG_GETTING_ITINERARY_ARRIVALS,
  CLEAR_ITINERARY_ARRIVALS,
  GET_BUS_MAINTENANCE_STAY_DEMAND,
  FLAG_GETTING_BUS_MAINTENANCE_STAY_DEMAND,
  CLEAR_BUS_MAINTENANCE_STAY_DEMAND,
  GET_EXTENDED_BUS_MAINTENANCE_STAYS,
  FLAG_GETTING_EXTENDED_BUS_MAINTENANCE_STAYS,
  CLEAR_EXTENDED_BUS_MAINTENANCE_STAYS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),

  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),

  itineraryArrivals: Immutable.Map({
    content: Immutable.List(),
    activity: Immutable.List(),
  }),

  busMaintenanceStayDemand: Immutable.Map({
    content: Immutable.Map(),
    loading: false,
  }),

  extendedMaintenance: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUSSES_MAINTENANCE_STAY:
      return state.setIn(['all', 'loading'], payload);

    case GET_BUSSES_MAINTENANCE_STAY:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_BUSSES_MAINTENANCE_STAY:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_BUS_MAINTENANCE_STAY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_BUS_MAINTENANCE_STAY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_BUS_MAINTENANCE_STAY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case FLAG_GETTING_ITINERARY_ARRIVALS:
      if (payload) {
        return state.setIn(
          ['itineraryArrivals', 'activity'],
          state.getIn(['itineraryArrivals', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['itineraryArrivals', 'activity'],
        state.getIn(['itineraryArrivals', 'activity']).pop(),
      );

    case GET_ITINERARY_ARRIVALS:
      return state.setIn(
        ['itineraryArrivals', 'content'],
        Immutable.fromJS(payload),
      );

    case CLEAR_ITINERARY_ARRIVALS:
      return state.setIn(
        ['itineraryArrivals', 'content'],
        INITIAL_STATE.getIn(['itineraryArrivals', 'content']),
      );

    case FLAG_GETTING_BUS_MAINTENANCE_STAY_DEMAND:
      return state.setIn(['busMaintenanceStayDemand', 'loading'], payload);

    case GET_BUS_MAINTENANCE_STAY_DEMAND:
      return state.setIn(
        ['busMaintenanceStayDemand', 'content'],
        Immutable.Map(payload),
      );

    case CLEAR_BUS_MAINTENANCE_STAY_DEMAND:
      return state.setIn(
        ['busMaintenanceStayDemand', 'content'],
        INITIAL_STATE.getIn(['busMaintenanceStayDemand', 'content']),
      );

    case FLAG_GETTING_EXTENDED_BUS_MAINTENANCE_STAYS:
      return state.setIn(['extendedMaintenance', 'loading'], payload);

    case GET_EXTENDED_BUS_MAINTENANCE_STAYS:
      return state.setIn(
        ['extendedMaintenance', 'content'],
        Immutable.fromJS(payload),
      );

    case CLEAR_EXTENDED_BUS_MAINTENANCE_STAYS:
      return state.set(
        'extendedMaintenance',
        INITIAL_STATE.get('extendedMaintenance'),
      );

    default:
      return state;
  }
};
